export default function HeroTitle() {
  return (
    <div className="flex flex-col items-center" style={{ animationDelay: '150ms' }}>
      <h2 className="text-[26px] font-bold text-[#1F2024] leading-[1.35] text-center whitespace-pre-line">
        {`당신의 피부를 위한\n2분의 준비`}
      </h2>
      <p className="text-sm text-[#55575D] mt-4 text-center leading-relaxed whitespace-pre-line">
        {`방문 전 몇 가지만 여쭤볼게요.\n맞춤 케어를 준비해 드릴게요.`}
      </p>
    </div>
  );
}